import usePreferredDateFormat from '@/hooks/usePreferredDateFormat';
import { isoDateToLocalDate } from '@payaca/custom-fields';
import {
  CustomFieldDateFormatProvider,
  type IsoDateFormatter,
} from '@payaca/custom-fields-react';
import { DateFormats } from '@payaca/helpers/internationalHelper';
import { format } from 'date-fns';
import { FC, PropsWithChildren, useCallback } from 'react';

/**
 * Formats date custom fields using the user's preferred date format so they
 * match every other date shown in the provider app, rather than the browser's
 * default locale.
 */
const CustomFieldDateFormatContextProvider: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const dateFormat = usePreferredDateFormat(DateFormats.SHORT);

  const formatter = useCallback<IsoDateFormatter>(
    (isoDate) => {
      const date = isoDateToLocalDate(isoDate);
      return date ? format(date, dateFormat) : isoDate;
    },
    [dateFormat]
  );

  return (
    <CustomFieldDateFormatProvider formatter={formatter}>
      {children}
    </CustomFieldDateFormatProvider>
  );
};

export default CustomFieldDateFormatContextProvider;
